/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DropdownCategories_allCategories$ref: FragmentReference;
declare export opaque type DropdownCategories_allCategories$fragmentType: DropdownCategories_allCategories$ref;
export type DropdownCategories_allCategories = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +name: string,
      +picture: ?string,
    |}
  |}>,
  +$refType: DropdownCategories_allCategories$ref,
|};
export type DropdownCategories_allCategories$data = DropdownCategories_allCategories;
export type DropdownCategories_allCategories$key = {
  +$data?: DropdownCategories_allCategories$data,
  +$fragmentRefs: DropdownCategories_allCategories$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DropdownCategories_allCategories",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeCategoryNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeCategoryNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "picture",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecipeCategoryNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '16043b286e01d655280bce3b54eef2cf';

module.exports = node;
